<details [class]="'row ' + rowTone()" (toggle)="onToggle($event)">
  <summary>
    <span class="badge">{{ statusLabel() }}</span>
    <span class="who">
      <strong>{{ app().name ?? 'Unknown application' }}</strong
      >&ngsp;
      @if (app().roleName) {
        <span class="role">{{ app().roleName }}</span>
      }
    </span>
    <span class="why">{{ why() }}</span>
    <span class="age" [class.stale]="stale()" [attr.title]="app().checkedAt">
      {{ stale() ? 'Old data, ' : '' }}{{ age() }}
    </span>
  </summary>
  @if (open()) {
    <div class="body">
      <app-health-card [app]="app()" [now]="now()" [staleAfterMs]="staleAfterMs()" />
    </div>
  }
</details>
